import Text from '@/components/view/atoms/text/Text'

interface Props {
  percent: number
}

const RateBar = ({ percent }: Props) => {
  return (
    <div className='flex items-center gap-4'>
      <div className='bg-fill-tertiary flex h-3 w-full items-center overflow-hidden rounded-full'>
        <div
          className='bg-fill-primary-brand flex h-full rounded-full'
          style={{ width: percent + '%' }}
        />
      </div>
      <div className='flex shrink-0 items-end gap-1'>
        <Text weight='bold' size={24}>
          {percent}
        </Text>
        <Text size={14}>%</Text>
      </div>
    </div>
  )
}

export default RateBar
